/**
 * @ Author: Housefolios
 * @ Create Time: 2021-11-22 08:46:15
 * @ Modified by: TJ Felman
 * @ Modified time: 2022-03-21 13:22:52
 * @ Description: Dialog to delete a property
 */

import React, { useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Dialog, Box } from '@mui/material'

import BlockUi from 'react-block-ui'
import { removeAuthToken } from '@/utils/auth'

function SessionDialog(props) {
  function handleLogIn() {
    removeAuthToken()
    window.location.reload()
  }
  return (
    <>
      <Dialog
        open={true}
        onClose={handleLogIn}
      >
        <BlockUi
          // blocking={}
          // loader={
          //   <PacmanLoader color={'var(--primary)'} loading={true} />
          // }
          message={
            <Box sx={{ color: '#368cff' }}>
              Redirecting to log in page...
            </Box>
          }
        >
          <Box sx={{ textAlign: 'center', p: '3rem' }}>
            <Box sx={[{ borderRadius: '50%', m: 0 }, {
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              mr: "0.25rem",
              position: "relative",
              fontSize: "1.2rem",
              transition: "all 0.2s ease-in-out",
              "&:last-child": { mr: 0, marginRight: 0 },
              "& .badge": { position: "absolute", right: 0, bottom: 0 },
              "& svg, & .svg-inline--fa": { display: "block" },
              marginRight: "0.25rem",
            }]}>
              <Box sx={[{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                border: 0,
                backgroundColor: "rgb(100%, 95.9215686275%, 96.418938307%) !important",
                height: "130px !important",
                width: "130px !important",
                lineHeight: "130px !important",
                p: 0,
                borderRadius: "50%",
                color: "#f83245",
                m: 0,
              }, {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                mr: "0.25rem",
                position: "relative",
                fontSize: "1.2rem",
                transition: "all 0.2s ease-in-out",
                "&:last-child": { mr: 0, marginRight: 0 },
                "& .badge": { position: "absolute", right: 0, bottom: 0 },
                "& svg, & .svg-inline--fa": { display: "block" },
                marginRight: "0.25rem",
              }]}>
                <FontAwesomeIcon
                  icon={['far', 'clock']}
                  style={{ display: 'block', fontSize: '2.5rem', fontWeight: 300, lineHeight: 1 }}
                />
              </Box>
            </Box>
            <Box
              component="h4"
              sx={{ fontWeight: 700, mt: '1.5rem' }}
            >
              Your session expired. Please log back in.
            </Box>
            <Box sx={{ pt: '1.5rem' }}>
              <Button
                variant="contained"
                style={{ backgroundColor: '#f83145', color: 'white' }}
                onClick={handleLogIn}
                //
              >
                <Box component="span" sx={{
                  display: "inline-block",
                  "&:not(:first-of-type)": { ml: "0.5rem", marginLeft: "0.5rem" },
                  "& + .btn-wrapper--icon": { ml: "0.5rem", marginLeft: "0.5rem" },
                }}>Log In</Box>
              </Button>
            </Box>
          </Box>
        </BlockUi>
      </Dialog>
    </>
  )
}

export default SessionDialog
